import React, { useEffect, useState } from 'react'
import SbEditable from 'storyblok-react'
import StoryblokService from '../utils/storyblok-service'
import { AuthorCard } from './ui/author-card'
import RichText from '@/utils/RichText'

const Author = blok => {
  const [story, setStory] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await StoryblokService.get(
          `cdn/stories/?by_uuids=${blok.uuid}`,
        )
        setStory(response.data.stories[0].content)
      } catch (error) {
        console.error('Error fetching story:', error)
      }
    }

    fetchData()
  }, [blok.uuid])
  return (
    <SbEditable content={{ blok }}>
      {story && (
        <AuthorCard
          name={story?.AuthorName}
          position={story?.AuthorDesignation}
          avatar={story?.AuthorAvatart?.filename}
          content={<RichText>{story?.Description}</RichText>}
          variant={story?.Variant}
          socialLinks={{
            x: story?.x,
            linkedin: story?.linkedin,
            facebook: story?.facebook,
          }}
        />
      )}
    </SbEditable>
  )
}

export default Author
